//# sourceMappingURL=my-marked-dates.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module id = 1201
// module chunks = 10